"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _utils = require('shared/store/utils');
var _helpers = require('shared/actions/helpers');



















var _store = require('shared/store');







var _translation = require('shared/selectors/translation');

const getConversationTranslationActions =
  _utils.createAsyncActions('GetConversationTranslation')
const setPatientTranslationActions = _utils.createAsyncActions('SetPatientTranslation')
const stopTranslatingActions = _utils.createAsyncActions('StopTranslating')
const markMessageEnglishActions = _utils.createAsyncActions('MarkMessageEnglish')
const translateFromMessageActions = _utils.createAsyncActions('TranslateFromMessage')
const previewReplyTranslationActions = _utils.createAsyncActions('PreviewReplyTranslation')
const getLanguageSuggestionsActions = _utils.createAsyncActions('GetLanguageSuggestions')
const getOrgTranslationSettingsActions =
  _utils.createAsyncActions('GetOrgTranslationSettings')
const updateOrgTranslationSettingsActions =
  _utils.createAsyncActions('UpdateOrgTranslationSettings')

/* A chat view showing this chat mounted or unmounted. */
const translationChatOpenedAction = _utils.createAction('Translation chat opened')
const translationChatClosedAction = _utils.createAction('Translation chat closed')
/* A Translate in this chat was sent, or answered (whatever the answer). */
const translateFromMessageStartedAction = _utils.createAction('Translate from message started')
const translateFromMessageFinishedAction = _utils.createAction('Translate from message finished')
/* Staff dismissed the "Not English · Translate?" pill in this chat.
 * Remembered for this app session only (never sent or stored). */
const translationPillDismissedAction = _utils.createAction('Translation pill dismissed')
/* Translate found a language to offer for the patient (selectLanguageOffer),
 * and staff answered it. */
const languageOfferedAction = _utils.createAction('Language offered')
const languageOfferClosedAction = _utils.createAction.call(void 0, 'Language offer closed')
/* Drop cached chat states (all of them without ConversationKeys); answers to
 * requests sent before this are ignored. */
const translationStatesInvalidatedAction = _utils.createAction.call(void 0, 
  'Translation states invalidated',
  (payload, seq) => ({ payload, meta: { seq } }),
)

 const actionCreators = {
  getConversationTranslationActions,
  setPatientTranslationActions,
  stopTranslatingActions,
  markMessageEnglishActions,
  translateFromMessageActions,
  previewReplyTranslationActions,
  getLanguageSuggestionsActions,
  getOrgTranslationSettingsActions,
  updateOrgTranslationSettingsActions,
  translationChatOpenedAction,
  translationChatClosedAction,
  translateFromMessageStartedAction,
  translateFromMessageFinishedAction,
  translationPillDismissedAction,
  languageOfferedAction,
  languageOfferClosedAction,
  translationStatesInvalidatedAction,
}; exports.actionCreators = actionCreators

/* Request sequence for the reducer's stale-answer check (see
 * TranslationSyncSliceState): a read is stamped when it is sent, a write
 * when it succeeds, so a read sent before a write landed never overwrites
 * the write's answer. */
let lastSeq = 0
const nextSeq = () => ++lastSeq







const stampedOnSuccess = (acts) => ({
  REQUEST: acts.REQUEST,
  FAILURE: acts.FAILURE,
  SUCCESS: (payload, meta) => acts.SUCCESS(payload, { ...meta, seq: nextSeq() }),
})

const getConversationTranslation = (req) =>
  _helpers.wsCommand(
    'GetConversationTranslation', getConversationTranslationActions, req, { seq: nextSeq() },
  )

const setPatientTranslation = (req) =>
  _helpers.wsCommand(
    'SetPatientTranslation', stampedOnSuccess(setPatientTranslationActions), req, null,
  )

const stopTranslating = (req) =>
  _helpers.wsCommand('StopTranslating', stampedOnSuccess(stopTranslatingActions), req, null)

const markMessageEnglish = (req) =>
  _helpers.wsCommand(
    'MarkMessageEnglish', stampedOnSuccess(markMessageEnglishActions), req, null,
  )

/* What staff see after Translate (the pill or a message's options menu):
 * nothing when it worked, otherwise why nothing changed. */
 const TRANSLATE_FROM_MESSAGE_NOTICES = {
  english: 'This message is in English. Nothing to translate.',
  failed: "Couldn't update translation. Try again.",
}; exports.TRANSLATE_FROM_MESSAGE_NOTICES = TRANSLATE_FROM_MESSAGE_NOTICES

/* Translate one patient message: the server has Google translate it and
 * keeps that translation; the patient's language doesn't change. When the
 * patient has no language saved, the language found is offered
 * (selectLanguageOffer: "Set Rosa's language to French?") and the chat's
 * pill is put away, as Translate answered it. One runs per chat at a time,
 * wherever it was chosen (the pill, either app's options menu): while one
 * waits, the chat is marked translating (selectIsTranslatingFromMessage)
 * and another resolves at once to null without being sent. Resolves to the
 * notice to show, or null when the message was translated; it never
 * rejects. */
const translateFromMessage = (req) => {
  const key = req.ConversationKey
  if (_translation.selectIsTranslatingFromMessage.call(void 0, _store.getState.call(void 0, ), key)) return Promise.resolve(null)
  _store.dispatch.call(void 0, translateFromMessageStartedAction(key))
  return _helpers.wsCommand(
    'TranslateFromMessage', stampedOnSuccess(translateFromMessageActions), req, null,
  ).then(
    ({ Outcome, OfferLanguage, PatientKey, PatientFirstName }) => {
      if (Outcome !== 'translated') return _nullishCoalesce(exports.TRANSLATE_FROM_MESSAGE_NOTICES[Outcome], () => ( null))
      _store.dispatch.call(void 0, translationPillDismissedAction({ ConversationKey: key }))
      if (OfferLanguage && PatientKey) {
        _store.dispatch.call(void 0, languageOfferedAction({
          ConversationKey: key, PatientKey, FirstName: _nullishCoalesce(PatientFirstName, () => ( '')), Language: OfferLanguage,
        }))
      }
      return null
    },
    () => exports.TRANSLATE_FROM_MESSAGE_NOTICES.failed,
  ).finally(() => _store.dispatch.call(void 0, translateFromMessageFinishedAction(key)))
}

/* Staff's answer to the language offer. Set language sets the patient's
 * language with always-translate (a patient setting: every chat with them),
 * which translates this chat's recent messages; Not now changes nothing.
 * Resolves to the notice to show, or null; it never rejects. */
const answerLanguageOffer = (setLanguage) => {
  const offer = _optionalChain([_store.getState.call(void 0, ), 'access', _ => _.translationSync, 'optionalAccess', _2 => _2.languageOffer])
  _store.dispatch.call(void 0, languageOfferClosedAction())
  if (!setLanguage || !offer) return Promise.resolve(null)
  return setPatientTranslation({
    ConversationKey: offer.ConversationKey,
    PatientKey: offer.PatientKey,
    Language: offer.Language,
    AlwaysTranslate: true,
  }).then(() => null, () => exports.TRANSLATE_FROM_MESSAGE_NOTICES.failed)
}

/* Hides the chat's pill until the app restarts or the user logs out. Nothing is
 * sent: the server keeps offering the pill until the patient has a
 * language. */
const dismissTranslationPill = (req) => {
  _store.dispatch.call(void 0, translationPillDismissedAction(req))
}

/* The draft's translation per reply language, for the composer's Preview.
 * Not stored in the store: the caller shows it. */
const previewReplyTranslation = (req) =>
  _helpers.wsCommand('PreviewReplyTranslation', previewReplyTranslationActions, req, null)

/* The Language picker's suggestions for a patient. */
const getLanguageSuggestions = (req) =>
  _helpers.wsCommand('GetLanguageSuggestions', getLanguageSuggestionsActions, req, null)

const getOrgTranslationSettings = (req) =>
  _helpers.wsCommand(
    'GetOrgTranslationSettings', getOrgTranslationSettingsActions, req, { seq: nextSeq() },
  )

const invalidateConversationTranslations = (conversationKeys) => {
  if (conversationKeys && !conversationKeys.length) return
  _store.dispatch.call(void 0, translationStatesInvalidatedAction({ ConversationKeys: conversationKeys }, nextSeq()))
}

/* Background refetches after a push or a settings change. Optional reads
 * share the socket with staff commands, and the server buffers only a few
 * commands per connection, so they are coalesced (one per chat or org per
 * window), wait REFRESH_DELAY_MS so a burst of pushes costs one round, and
 * run at most MAX_REFRESHES_IN_FLIGHT at a time. */
const REFRESH_DELAY_MS = 300
const MAX_REFRESHES_IN_FLIGHT = 2



const queuedRefreshes = new Map()
let refreshTimer = null
let refreshesInFlight = 0
let idleWaiters = []

const settleIfIdle = () => {
  if (refreshTimer || queuedRefreshes.size || refreshesInFlight) return
  const waiters = idleWaiters
  idleWaiters = []
  waiters.forEach(resolve => resolve())
}

const pumpRefreshes = () => {
  for (const [id, run] of queuedRefreshes) {
    if (refreshesInFlight >= MAX_REFRESHES_IN_FLIGHT) break
    queuedRefreshes.delete(id)
    refreshesInFlight++
    run()
      // An optional refresh: a failure leaves the chat as invalidated.
      .catch(() => undefined)
      .finally(() => {
        refreshesInFlight--
        pumpRefreshes()
      })
  }
  settleIfIdle()
}

/* Resolves once every queued refresh has finished. */
const scheduleRefreshes = (refreshes) => {
  if (!refreshes.length) return Promise.resolve()
  for (const [id, run] of refreshes) {
    if (!queuedRefreshes.has(id)) queuedRefreshes.set(id, run)
  }
  refreshTimer ??= setTimeout(() => {
    refreshTimer = null
    pumpRefreshes()
  }, REFRESH_DELAY_MS)
  return new Promise(resolve => idleWaiters.push(resolve))
}

/* Refetch an open chat; one closed since it was queued is dropped instead,
 * and refetches when it next opens. */
const chatRefresh = (conversationKey) => [
  `chat:${conversationKey}`,
  () => {
    if (_translation.selectIsTranslationConversationActive.call(void 0, _store.getState.call(void 0, ), conversationKey)) {
      return getConversationTranslation({ ConversationKey: conversationKey }).then(() => undefined)
    }
    invalidateConversationTranslations([conversationKey])
    return Promise.resolve()
  },
]

const refreshActiveConversationTranslations = (filter) =>
  scheduleRefreshes(_translation.selectActiveTranslationConversationKeys.call(void 0, _store.getState.call(void 0, ))
    .filter(key => !filter || filter(key))
    .map(chatRefresh))

/* Org settings are a whole record the next toggle sends back, and every
 * chat's state carries the org's switch: on success all chat states are
 * dropped (in the reducer) and the open chats refetch. */
const updateOrgTranslationSettings = (req) =>
  _helpers.wsCommand(
    'UpdateOrgTranslationSettings', stampedOnSuccess(updateOrgTranslationSettingsActions), req, null,
  ).then((settings) => {
    refreshActiveConversationTranslations()
    return settings
  })

/* Chat views mounting and unmounting (useConversationTranslationSync).
 * Pushes refetch only the chats some view shows. */
const openConversationTranslation = (conversationKey) => {
  _store.dispatch.call(void 0, translationChatOpenedAction(conversationKey))
}

const closeConversationTranslation = (conversationKey) => {
  _store.dispatch.call(void 0, translationChatClosedAction(conversationKey))
}

/* ConversationTranslationChanged push. Only open chats refetch; any other
 * cached state it may touch is dropped and refetches when its chat opens.
 * - {ConversationKey}: that chat;
 * - {OrgKey, PatientKey}: that patient's chats (open ones with no state yet
 *   too, as the patient isn't known for them);
 * - {OrgKey}: the org's settings changed. Chat states don't say their org,
 *   so all are dropped and every open chat refetches, with the org's
 *   settings if they're loaded. */
const handleConversationTranslationChanged = (data) => {
  const state = _store.getState.call(void 0, )
  const cached = Object.values(_nullishCoalesce(state.conversationTranslations, () => ( {})))
  const isActive = (key) => _translation.selectIsTranslationConversationActive.call(void 0, state, key)

  if (_optionalChain([data, 'optionalAccess', _3 => _3.ConversationKey])) {
    const key = data.ConversationKey
    if (isActive(key)) return scheduleRefreshes([chatRefresh(key)])
    if (_translation.selectConversationTranslation.call(void 0, state, key)) invalidateConversationTranslations([key])
    return Promise.resolve()
  }
  if (!_optionalChain([data, 'optionalAccess', _4 => _4.OrgKey])) return Promise.resolve()

  if (data.PatientKey) {
    const patientKey = data.PatientKey
    invalidateConversationTranslations(cached
      .filter(t => _translation.hasChatPatient.call(void 0, t, patientKey) && !isActive(t.ConversationKey))
      .map(t => t.ConversationKey))
    return refreshActiveConversationTranslations((key) => {
      const translation = _translation.selectConversationTranslation.call(void 0, state, key)
      return !translation || _translation.hasChatPatient.call(void 0, translation, patientKey)
    })
  }

  invalidateConversationTranslations()
  const orgKey = data.OrgKey
  const refreshes = _translation.selectActiveTranslationConversationKeys.call(void 0, state).map(chatRefresh)
  if (_translation.selectOrgTranslationSettings.call(void 0, state, orgKey)) {
    refreshes.push([`org:${orgKey}`, () => getOrgTranslationSettings({ OrgKey: orgKey }).then(() => undefined)])
  }
  return scheduleRefreshes(refreshes)
}

exports. default = {
  getConversationTranslation,
  setPatientTranslation,
  stopTranslating,
  markMessageEnglish,
  translateFromMessage,
  answerLanguageOffer,
  dismissTranslationPill,
  previewReplyTranslation,
  getLanguageSuggestions,
  getOrgTranslationSettings,
  updateOrgTranslationSettings,
  openConversationTranslation,
  closeConversationTranslation,
  handleConversationTranslationChanged,
}
